<template>
  <div class="game-dialog-page" v-if="gameDialogShow" ref="gamePage">
    <div class="game-dialog-content" ref="gameDialog">
      <div class="title-pointer" @click.stop="hideGameDialog"></div>
      <div class="main-panel">
        <div class="grid-panel">
          <img :class="'game-item '+wrapCls(index)" v-for="(game,index) in gameList" @click.stop="toGame(game)"
               :src="game.picture" :onerror="errorImage">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {hideDialog, isnull, Toast} from "../../utils/tools";
  import EventBusConstant from "../../push/const/EventBusConstant";
  import icondefaulthead from '../../assets/imgs/icon_default_head.png'
  import StatisticsHelper from "../../utils/StatisticsUtils";

  export default {
    name: "gamedialog",
    props: {
      type: 0,
      gameList: {
        type: Array,
        default: []
      },
      gameDialogShow: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        errorImage: 'this.src="' + icondefaulthead + '"'
      }
    },
    methods: {
      wrapCls(index) {
        let cls = '';
        if (index % 4 == 0) {
          cls += 'left '
        }
        if (index < 4) {
          cls += 'top '
        }
        return cls
      },
      toGame(game) {
        if (isnull(game))
          return
        if (!this.$root.online) {
          Toast.error('No network', this)
          hideDialog(this)
          return
        }
        let url = game.gameAdress
        let rate=game.rate
        this.$EventBus.$emit(EventBusConstant.EVENT_SHOW_HC, 3, url,rate)
        StatisticsHelper.track_click_game_banner(this.type, game.gameName)
        let _this = this
        // setTimeout(() => {
        //   _this.hideGameDialog()
        // }, 100)
      },
      hideGameDialog() {
        this.$emit('hideGame')
      },
      bodyCloseGameDialog(e) {
        let self = this;
        if (this.$refs.gameDialog && !this.$refs.gameDialog.contains(e.target)) {
          // self.hideGameDialog();
        }
      },
    },
    watch: {
      gameDialogShow(n, o) {
        if (n) {
          $('.page-container').scrollTop(0)
          $('.page-container').css('overflow-y', 'hidden')
          let target = this
          setTimeout(function () {
            target.$refs.gamePage.addEventListener("click", target.bodyCloseGameDialog);
          }, 100)

        } else {
          $('.page-container').css('overflow-y', 'auto')
          this.$refs.gamePage.removeEventListener("click", this.bodyCloseGameDialog);
        }
      }
    }

  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .game-dialog-page {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;

    .game-dialog-content {
      width: 100%;
      .h(632);
      position: absolute;
      bottom: 0;

      .title-pointer {
        .w(310);
        .h(70);
        background: url(../../assets/imgs/game/game_dialog_pointer.png) no-repeat;
        background-size: contain;
        margin-left: 50%;
        transform: translateX(-50%);
      }

      .main-panel {
        width: 100%;
        .h(587);
        .mt(-28);
        background: url(../../assets/imgs/game/game_dialog_bg.png) no-repeat;
        background-size: contain;

        .grid-panel {
          position: absolute;
          margin-left: 50%;
          transform: translateX(-50%);
          .mt(132);
          .w(608);
          .h(398);
          overflow-y: auto;
          white-space: nowrap;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          align-content: flex-start;

          .game-item {
            .w(110);
            .h(110);
            .ml(54);
            .mt(34);

          }

          .game-item.left {
            margin-left: 0;
          }

          .game-item.top {
            margin-top: 0;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/widget/gamedialog.vue